import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import XuatExcelApi from "service/xuatExcelApi";

export const XuatExcelKySo = ({ dataSearch, show, onHide }) => {
  const [percent, setPercent] = useState(0);
  const [message, setMessage] = useState(
    "Đang phân tích dữ liệu. Vui lòng chờ đến khi xuất được tập tài liệu.",
  );

  useEffect(() => {
    if (!show) return;

    let canceled = false;
    const fetchExportFile = async () => {
      try {
        setPercent(10);
        setMessage("Đang tải dữ liệu xuất Excel...");

        const response = await XuatExcelApi.duLieuKySo(
          dataSearch.sSearch,
          dataSearch.sLoaiHopDong,
          dataSearch.tuNgay,
          dataSearch.denNgay,
          dataSearch.sTrangThai,
        );

        if (!response || !response.ok) {
          const message =
            response?.problem || response?.data || "Lỗi khi tải file Excel.";
          throw new Error(message);
        }

        if (canceled) return;

        const blobData = response.data;
        if (!blobData) {
          throw new Error("Không có dữ liệu trả về từ API xuất Excel.");
        }

        const contentDisposition =
          response.headers?.["content-disposition"] ||
          response.headers?.["Content-Disposition"] ||
          "";
        const filename =
          getFileNameFromContentDisposition(contentDisposition) ||
          `DanhSachHopDongKySo_${moment().format("YYYYMMDDHHmmss")}.xls`;

        setPercent(70);
        setMessage("Đang tạo file Excel...");

        const blob = new Blob([blobData], {
          type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.setAttribute("download", filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);

        setPercent(100);
        setMessage("Xuất Excel thành công. File đang được tải xuống...");
      } catch (error) {
        console.error("Lỗi xuất Excel ký số:", error);
        setMessage(
          error?.message || "Lỗi khi tải dữ liệu xuất Excel. Vui lòng thử lại.",
        );
      }
    };

    fetchExportFile();
    return () => {
      canceled = true;
    };
  }, [show, dataSearch]);

  const getFileNameFromContentDisposition = (contentDisposition) => {
    if (!contentDisposition) return null;

    const fileNameMatch =
      /filename\*=UTF-8''([^;\n\r]+)|filename="?([^";\n\r]+)"?/.exec(
        contentDisposition,
      );

    if (!fileNameMatch) return null;
    return decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <Modal.Title>Xuất Excel danh sách ký số</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-thongtin-kh-new">
          <div style={{ textAlign: "center", marginBottom: 16 }}>{message}</div>
          <div
            style={{
              width: "100%",
              backgroundColor: "#eee",
              height: 18,
              borderRadius: 4,
            }}
          >
            <div
              style={{
                width: `${percent}%`,
                backgroundColor: "#006266",
                height: 18,
                textAlign: "center",
                color: "#fff",
                fontSize: 12,
                lineHeight: "18px",
                borderRadius: 4,
              }}
            >
              {percent} %
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
